import gql from "graphql-tag";

export default gql`
  query Kpis($tickerSymbol: String!) {
    kpis(tickerSymbol: $tickerSymbol) {
      currency
      reportDates {
        annual
        quarterly
        isTrailingTwelveMonths
      }
      annual {
        ...KeyPerformanceIndicatorFields
      }
      quarterly {
        ...KeyPerformanceIndicatorFields
      }
    }
  }

  fragment KeyPerformanceIndicatorFields on KeyPerformanceIndicator {
    name
    format
    isDiscontinued
    isImportant
    isCurrency
    series
  }
`;
